import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import esTranslation from './locales/es/translation.json';
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: { es: { translation: esTranslation } },
    fallbackLng: 'es',
    interpolation: { escapeValue: false },
  });
export default i18n;
